export enum SectionType {
    SIM_CARD = 'SIM_CARD',
    PURCHASE_NOTICE = 'PURCHASE_NOTICE',
    INTRODUCTION = 'INTRODUCTION',
    SUGGESTED_ROUTE = 'SUGGESTED_ROUTE',
    GRAPHIC = 'GRAPHIC',
    SURCHARGE = 'SURCHARGE',
    UNKNOWN = 'UNKNOWN',
}
